import { AssignmentFilterService } from '../../../Services/filter.service';
import { SelectionService } from '../../../Services/selection.service';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { ClassForListing, GradebookVM, ClassWithStudentsForListing, CreateAssignmentOptions } from 'src/app/Elearning-Models';
import { GradebookDataService } from 'src/app/Services/gradebookData.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { ColorCodes, StatusLabel } from 'src/app/ColorCodes';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { APIServiceMock } from 'src/app/Services/API-Service/api-service-mock';
import { AdvanceAssignDialogComponent } from '../shared/advance-assign-dialog/advance-assign-dialog.component';

export interface Filter {
  name: string;
  completed: boolean;
  subtasks?: Filter[];
}

@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.scss'],
})

export class ClassComponent implements OnInit, OnDestroy { showCreateAssignments: boolean = false;
  paginator: MatPaginator;
  selectionService: SelectionService;
  assignmentFilterService: AssignmentFilterService;
  dataService: GradebookDataService;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  filteredClass: Observable<ClassForListing[]>;
  filterSubscription: Subscription;

  collapsedWidth: number = 100;
  classDataInitialized: boolean = false;
  classID: string;
  className: string;
  searchStudentValue: string = '';
  searchLessonValue: string = '';
  classViewHeaders: {};
  classData: any[] = [];
  headerArray = [];
  unitHeaderObject = {};
  unitHeaderDetails = {
    nameArray: [],
    headerArray: []
  };

  unitHeadersToDisplay: any[] = [];
  unitNamesToDisplay: string[] = [];

  displayedColumns: string[] = [];
  columnsToDisplay: string[] = [];
  filteredColumns: string[] = [];
  selectedAssignmentsObject = [];

  classOptions: ClassForListing[] = [];
  colorIndicators = new ColorCodes().colorIndicators;

  filterValue: any;
  dataSource = new MatTableDataSource();
  classControl = new FormControl();

  needsAttentionFilterEmpty: boolean = false;
  noCurriculum: boolean = false;
  assignmentDefaultData: CreateAssignmentOptions;
  arrClassWithStudent: ClassWithStudentsForListing[] | ClassForListing[];
  isAdmin = false;
  assignmentId: string;
  studentId: string;
  constructor(
    // private selectionService: SelectionService,
    //private assignmentFilterService: AssignmentFilterService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    private toastr: ToastrService,
    private aPIServiceMock: APIServiceMock
  ) {
    this.dataService = this.serviceFactory.getGradebookDataService();
    this.selectionService = this.serviceFactory.getSelectionService();
    this.assignmentFilterService = this.serviceFactory.getAssignmentFilterService();
    //this.GetClassesWithStudent();
  }

  ngOnInit(): void {
    this.dataService.ShowGradebookStudentAssignmentCreateAssignmentInterface().subscribe( result => {
      this.showCreateAssignments = result;
    });

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.classID = params.get('id');
    });
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.assignmentId = queryParams.get('assignmentId');
    });
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.studentId = queryParams.get('studentId');
    });
    this.isAdmin = this.aPIServiceMock.isAdmin;
    this.getClassOptions();

    this.filterSubscription = this.assignmentFilterService.currentFilterValue.subscribe((filterValue) => {
      this.setFilterValues(filterValue);
    });

    this.dataSource.filterPredicate = function (data: any, filter: string): boolean {
      return data.Student.cellValue.toLowerCase().includes(filter);
    };

    this.setClassData('init');
  }

  getClassOptions = () => {
    this.dataService.GetClassListByTeacher().subscribe(
      (response: ClassForListing[]) => {
        this.classOptions = response;
        this.filteredClass = this.classControl.valueChanges.pipe(
          startWith(''),
          map((value) => this._filterClassByName(value))
        );
    });
  }

  processClassData = (Class: GradebookVM) =>
  {
    // prep headers and raw data objects
    this.classViewHeaders = {};
    this.unitHeaderObject = {};
    let classRawData = {};

    this.unitHeaderObject['StudentUnit'] = {
      count: 1,
      id: 0,
      label: 'StudentUnit',
      lessonVersionIDs: ['Student'],
      hidden: false
    };

    this.classViewHeaders['0'] =
    {
      lessonVersionID: 'Student', // filler
      assignmentName: 'Student', // filler *gets set later
      sequence: 0,
      assignmentIDs: [],
      unitID: 0,
      width: 'auto'
    };

    Class.Assignments.sort((a,b) => this.sortAssignmentsByProperty(a,b, 'UnitID'));

    // set headers and raw data objects one assignment at a time
    Class.Assignments?.map((assignment) =>
    {
      var lessonVersionID = assignment.AssignedStudentAttempts[0].LessonID;

      if(assignment.UnitID) {
        if(!this.unitHeaderObject[assignment.UnitName]) {
          this.unitHeaderObject[assignment.UnitName] = {
            count: 1,
            id: assignment.UnitID,
            label: assignment.UnitName,
            lessonVersionIDs: [lessonVersionID.toString()],
            hidden: false
          }
        } else {
          this.unitHeaderObject[assignment.UnitName].count++;
          this.unitHeaderObject[assignment.UnitName].lessonVersionIDs.push(lessonVersionID.toString());
        }
      } else {
        if(!this.unitHeaderObject['null']) {
          this.unitHeaderObject[assignment.UnitName] = {
            count: 1,
            id: -1,
            label: 'No Unit ID',
            lessonVersionIDs: [lessonVersionID.toString()],
            hidden: false
          }
        } else {
          this.unitHeaderObject['null'].count++;
          this.unitHeaderObject['null'].lessonVersionIDs.push(lessonVersionID.toString());
        }
      }

      // Create a field for each LessonVersionID with Lesson details on the class View Header
      if (!this.classViewHeaders[lessonVersionID])
      {
        this.classViewHeaders[lessonVersionID] =
        {
          lessonVersionID: lessonVersionID.toString(),
          assignmentName: assignment.LessonName,
          sequence: assignment.Sequence,
          assignmentIDs: [],
          unitID: assignment.UnitID,
          width: 'auto'
        };
      }


      // Add assignment to LessonVersionID on the class View Header
      this.classViewHeaders[lessonVersionID].assignmentIDs
        .push(assignment.AssignmentID);

      var assignmentStudentAttempts = assignment.AssignedStudentAttempts.filter(asa => asa.StudentID != null);
      assignmentStudentAttempts.map((student) =>
      {
        // Create a field for each studentID just a shell on raw data
        if (!classRawData[student.StudentID])
        {
          classRawData[student.StudentID] = {};
        }

        // fill the studentID object with a student object with details on raw data
        if (!classRawData[student.StudentID]['Student'])
        {
          classRawData[student.StudentID]['Student'] = {
            cellValue: student.StudentName,
            filtered: false,
            studentColumn: true,
            studentName: student.StudentName,
          };
          classRawData[student.StudentID]['StudentID'] = student.StudentID;
        }

        // create lessonVersionID object and add details on raw data
        if (!classRawData[student.StudentID][lessonVersionID])
        {
          classRawData[student.StudentID][lessonVersionID] = {
            cellValue: null,
            filtered: false,
            studentColumn: false,
            assignments: [],
            status: '',
            statusWeight: 6,
            statusLabel: '',
          };
        }

        // populate assignment details on raw data
        classRawData[student.StudentID][lessonVersionID].assignments
          .push(
            {
              AssignmentID: assignment.AssignmentID,
              SentBack: student.SentBack,
              Graded: student.Graded,
              NeedsAttention: student.NeedsAttention,
              SubmittedAsComplete: student.SubmittedAsComplete,
              GradeReleased: student.GradeReleased,
              AnswerKeyReleased: student.AnswerKeyReleased,
              Grade: student.Grade,
              AttemptID: student.AttemptID,
              AttemptCount: student.AttemptCount,
              Status: student.Status,
            }
          );

        // set cell values
        this.assignCellStatus(
          classRawData,
          student,
          lessonVersionID
        );

        // clean up exceptions

        // set value to not graded when applicable
        if (student.SubmittedAsComplete && !student.Graded) {
          classRawData[student.StudentID][lessonVersionID][
            'cellValue'
          ] = 'N/G';
        }

        // What about multiple assignments with same LessonVersion? How are they weighted for average?
        // Assume whatever average we want, this is wrong.
        // TO DO : Calculate proper average of the student grades. n number of assignments instead of only 2. Integration 7
        let oldGrade =
          classRawData[student.StudentID][lessonVersionID][
            'cellValue'
          ];

        let newGrade = student.Grade;
        if (
          oldGrade !== null &&
          oldGrade !== 'N/G' &&
          oldGrade.length !== 0 &&
          newGrade?.length !== 0
        ) {

          var isOldNumber = !isNaN(Number(oldGrade));
          var isNewNumber = !isNaN(Number(newGrade));
          var isOldAndNewNumber = isOldNumber && isNewNumber;

          // average old and new if possible
          if (isOldAndNewNumber) {
            classRawData[student.StudentID][lessonVersionID][
              'cellValue'
            ] = ((Number(oldGrade) + Number(newGrade)) / 2).toString();
          } else if (isNaN(Number(oldGrade))) {
            classRawData[student.StudentID][lessonVersionID][
              'cellValue'
            ] = newGrade;
          }
          // else if(isNaN(Number(newGrade))) {}
        } else {
          classRawData[student.StudentID][lessonVersionID][
            'cellValue'
          ] = newGrade;
        }
      }); // map

    });

    this.unitHeaderDetails.headerArray = [];
    this.unitHeaderDetails.nameArray = [];
    Object.keys(this.unitHeaderObject).map(unitKey => {
      this.unitHeaderDetails.nameArray.push(unitKey);
      this.unitHeaderDetails.headerArray.push(this.unitHeaderObject[unitKey]);
    });

    // Calculate student average, one student at a time
    // let currentClass = classRawData;
    Object.values(classRawData).map((studentRow) => {
      studentRow['Student']['cellValue'] += this.calculateStudentAverage(
        studentRow
      );
    });

    // Create Average
    classRawData['Average'] = {
      Student: { cellValue: 'Average' },
    };

    // Create lesson averages
    Object.keys(this.classViewHeaders).map((lvID) => {
      classRawData['Average'][lvID] = {};
      let sum = 0;
      let totalNumber = 0;
      Object.values(classRawData).map((studentRow: any) => {
        if (studentRow[lvID]) {
          let grade = Number(studentRow[lvID]['cellValue']);
          if (!isNaN(grade) && grade > 0) {
            sum += grade;
            totalNumber++;
          }
        }
      });
      classRawData['Average'][lvID] = {
        cellValue:
          totalNumber > 0 ? Math.round(sum / totalNumber).toString() : '-',
        filtered: false,
        studentColumn: null,
      };
    });
    return classRawData;
  };



  ///////////////////////////////////////////////////////////////////////////////////////
  getColorCode(label : string){
    return this.colorIndicators.find(color => color.label == label).color;
  }



  assignCellStatus = (classObj, student, lvID) => {
    let cell = classObj[student.StudentID][lvID];

    if(student.AssignmentID != null){
      if (cell['statusWeight'] >= 5 && student.Graded) {
        cell['statusWeight'] = 5;
        cell['statusLabel'] = StatusLabel.Graded;
        cell['status'] = this.getColorCode(cell['statusLabel']);
      }

      if (cell['statusWeight'] >= 4 && student.Graded && !student.GradeReleased) {
        cell['statusWeight'] = 4;
        cell['statusLabel'] = StatusLabel.GradeNotReleased;
        cell['status'] = this.getColorCode(cell['statusLabel']);
      }

      if (
        cell['statusWeight'] >= 3 &&
        student.SubmittedAsComplete &&
        !student.Graded
      ) {
        cell['statusWeight'] = 3;
        cell['statusLabel'] = StatusLabel.Ungraded;
        cell['status'] = this.getColorCode(cell['statusLabel']);
      }
      if (
        cell['statusWeight'] >= 2 &&
        !student.SubmittedAsComplete &&
        !student.SentBack
      ) {
        cell['statusWeight'] = 2;
        cell['statusLabel'] = StatusLabel.Assigned;
        cell['status'] = this.getColorCode(cell['statusLabel']);
      }
      if (cell['statusWeight'] >= 1 && student.SentBack) {
        cell['statusWeight'] = 1;
        cell['statusLabel'] = StatusLabel.SentBack;
        cell['status'] = this.getColorCode(cell['statusLabel']);
      }
      // SubmittedAsComplete false and SentBack false
    }


  };



  calculateStudentAverage = (studentRow) => {
    let sum = 0;
    let totalNumber = 0;
    Object.values(studentRow).map((assignment) => {
      let grade = Number(assignment['cellValue']);
      if (!isNaN(grade) && grade > 0) {
        sum += grade;
        totalNumber++;
      }
    });
    return ( ' ' + '(' + (totalNumber > 0 ? Math.round(sum / totalNumber).toString() : '-') + ')' );
  };



  setClassData = (type) => {
    this.classDataInitialized = false;
    if (this.classID){
      this.dataService.GetLessonProgressByClassID(+this.classID).subscribe(
        (response: GradebookVM) => {
          // this.setClassData(response);
          let classRawData = this.processClassData(response);
          this.className = response.ClassDetails.ClassName;
          this.populateClassArray(classRawData);
          this.populateHeaderArray(this.classViewHeaders);
          this.populateDisplayedColumns();
          this.classDataInitialized = true;
          this.filterClassData();
          if(this.assignmentId && type) {
            this.getSelectedAssignment(this.assignmentId, this.headerArray)
          }
        }
      );
    }
    else {
      this.classDataInitialized = true;
    }
  };



  clearClassValue = () => {
    this.classControl.setValue('');
  };



  populateClassArray = (classObj) => {
    this.classData = [];
    Object.values(classObj).map((studentRow) => {
      this.classData.push(studentRow);
    });
  };



  populateHeaderArray = (classViewHeaders) => {
    this.headerArray = [];
    Object.values(classViewHeaders).map((assignment) => {
      this.headerArray.push(assignment);
    });

    // this.headerArray.sort((a,b) => this.sortFunction(a,b));
    this.headerArray.sort((a,b) => this.sortAssignmentsByProperty(a,b, 'sequence'));
  };



  populateDisplayedColumns = () => {
    this.displayedColumns = this.headerArray.map((row) => row.lessonVersionID);
  };



///////////////////////////////////////////////////////////////////////////////////
  filterClassData = () => {
    let filteredClass = JSON.parse(JSON.stringify(this.classData));
    let rowsToDelete = [];

      filteredClass.map((studentRow, index) =>
      {
        let displayRow = studentRow.Student.cellValue === 'Average' ? true : false;
        // let displayRow = false;
        Object.values(studentRow).map((tableCell: any) => {
          if (tableCell.assignments?.length) {
            tableCell.assignments.map((assignment) => {
              if (this.assignmentFilterService.showData(assignment)) {
                tableCell.filtered = true;

                if (displayRow === false) {
                  displayRow = true;
                }
              }
            });
          }
        });
        if (!displayRow) {
          rowsToDelete.push(index);
        }
      });
      rowsToDelete.reverse().map((index) => {
        filteredClass.splice(index, 1);
      });

    this.filteredColumns = this.filterHeaders(filteredClass);

    this.applyLessonFilter();

    this.unitHeadersToDisplay = this.filterUnitHeaders();


    if(this.classData.length > 1 && filteredClass.length == 1){
      this.needsAttentionFilterEmpty = true;
    }
    else{
      this.needsAttentionFilterEmpty = false;
    }

    if(this.classData.length == 1){
      this.noCurriculum = true;
    }
    else{
      this.noCurriculum = false;
    }
    this.dataSource.data = filteredClass;
    if (this.studentId) {
      this.getSelectedStudent(this.studentId, this.dataSource.data)
    }
  };



/////////////////////////////////////////////////////////////////////////////
  filterHeaders = (filteredClass) => {
    if (this.filterValue.selectedFilter === 'common') {
      return this.displayedColumns;
    }
    let filteredColumns = ['Student'];
    var i;
    for (i = 1; i < this.displayedColumns.length; i++) {
      let displayColumn = false;
      filteredClass.map((studentRow) => {
        if (!displayColumn && studentRow[this.displayedColumns[i]]?.filtered) {
          displayColumn = true;
          filteredColumns.push(this.displayedColumns[i]);
        }
      });
    }
    return filteredColumns;
  };



  filterUnitHeaders = () => {
    this.unitHeadersToDisplay = [];
    this.unitNamesToDisplay = [];
    let unitHeadersToDisplay = JSON.parse(JSON.stringify(this.unitHeaderDetails.headerArray));
    unitHeadersToDisplay.map(unitHeader => {
      let filteredCount = 0;
      unitHeader.lessonVersionIDs.map(lessonVersionID => {
        if(this.columnsToDisplay.includes(lessonVersionID)) {
          filteredCount++
        }
      })
      unitHeader.count = filteredCount;
      if(filteredCount > 0) {
        this.unitNamesToDisplay.push(unitHeader.label);
      }
    })
    return unitHeadersToDisplay;
  }

  onCollapseAllUnits = () => {
    this.unitHeadersToDisplay.slice(1).map((unit, index) => {
      // if(this.unitHeadersToDisplay[index+1].count > 1) {
        this.onMinimizeClick(index+1);
      // }
    })
  }

  onExpandAllUnits = () => {
    this.unitHeadersToDisplay.slice(1).map((unit, index) => {
      this.onMaximizeClick(index+1);

    })
  }

  onMinimizeClick = (index) => {
    this.unitHeadersToDisplay[index].hidden = true;
    this.unitHeaderDetails.headerArray[index].hidden = true;

    let hiddenArray = [];
    this.unitHeadersToDisplay[index].lessonVersionIDs.map(lessonID => {
      hiddenArray.push(this.headerArray.findIndex(lessonObject => lessonObject.lessonVersionID == lessonID))
    });

    hiddenArray.map(index => {
      this.headerArray[index].width = (25 - hiddenArray.length*2)/hiddenArray.length;
    })
  }

  onMaximizeClick = (index) => {
    this.unitHeadersToDisplay[index].hidden = false;
    this.unitHeaderDetails.headerArray[index].hidden = false;

    this.unitHeadersToDisplay[index].lessonVersionIDs.map(lessonID => {
      let lessonIndex = this.headerArray.findIndex(lessonObject => lessonObject.lessonVersionID == lessonID);
      this.headerArray[lessonIndex].width = 'auto';
    });
  }

  applyLessonFilter = () => {
    let columnArray = [...this.filteredColumns];
    columnArray.shift();
    this.columnsToDisplay = columnArray.filter((lessonVersionID) =>
      this.classViewHeaders[lessonVersionID].assignmentName
        .toLowerCase()
        .includes(this.searchLessonValue.toLowerCase())
    );
    this.columnsToDisplay = ['Student', ...this.columnsToDisplay];

    this.unitHeadersToDisplay = this.filterUnitHeaders();
  };

  clearLessonValue = () => {
    this.searchLessonValue = '';
    this.applyLessonFilter();
  };




  populateAssignmentSelectionObject = () => {
    this.columnsToDisplay.slice(1).map(lessonVersionID => {
      const lessonObject = this.headerArray.find(header => header.lessonVersionID == lessonVersionID);
      this.selectedAssignmentsObject[lessonVersionID] = {selected: this.selectedAssignmentsObject[lessonVersionID]?.selected ? true : false, ...lessonObject}
    });

  }






  onLessonCheckboxClick = (checked, assignment) => {
    if(this.selectedAssignmentsObject && !this.selectedAssignmentsObject[assignment.lessonVersionID]) {
      this.selectedAssignmentsObject[assignment.lessonVersionID] = assignment;
    }
    this.selectedAssignmentsObject[assignment.lessonVersionID].selected = checked;
  }



  private setFilterValues(filterValue: any) {
    this.filterValue = filterValue;
    if (this.classDataInitialized) {
      this.filterClassData();
    }
  }



  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
  }



  applyStudentFilter() {
    this.dataSource.filter = this.searchStudentValue.trim().toLowerCase();
  }



  clearStudentValue = () => {
    this.searchStudentValue = '';
    this.applyStudentFilter();
  };



  trackByID = (index, item) => {
    return index;
  };



  onRowClick = (row) => {
    this.router.navigate([environment.rootPath + 'Student/' + row.StudentID]);
  };



  private _filterClassByName(value: string): ClassForListing[] {
    const filterValue = value.toLowerCase();
    return this.classOptions.filter((option) =>
      option.ClassName.toLowerCase().includes(filterValue)
    );
  }



  classChanged = (classID: string) => {
    if (this.classID != classID) {
      let queryParam = null;
      if(this.assignmentId) {
        queryParam =
        {
          queryParams: {
            assignmentId: this.assignmentId
          },
        }
      }
      if(this.studentId) {
        queryParam =
        {
          queryParams: {
            studentId: this.studentId
          },
        }
      }
      this.router.navigate([environment.rootPath + 'Class/' + classID] , queryParam ? queryParam : undefined);
      this.selectionService.setClassID(classID);
      this.classID = classID;
      this.setClassData(null);
      if (this.isAdmin) {
        this.GetClassesWithStudent();
      }
    }
  };



  onCellClick = (student, assignment) => {
    var lessonVersionID = assignment.lessonVersionID;
    if (student.Student.cellValue === 'Average')
    {
      // This is just the average row so do nothing
      return;
    }

    if (lessonVersionID === 'Student') {
      // this is the student, and should take you to the student page
      this.router.navigate(
        [environment.rootPath + 'Student/' + student.StudentID],
        {
          queryParams: {
            classID: this.classID,
            studentName: student.Student.studentName,
          }});
    }
    else if (student[lessonVersionID] && student[lessonVersionID]['statusWeight'] != 6)
    {
      if (assignment.assignmentIDs.length) {
        if (
          this.filterValue.selectedFilter === 'common' ||
          student[lessonVersionID].filtered
        ) {
          this.router.navigate(
            [environment.rootPath + 'Student/' + student.StudentID],
            {
              queryParams: {
                classID: this.classID,
                lessonVersionID: lessonVersionID,
                studentName: student.Student.studentName,
              },
            }
          );
        }
      } else {
      }
    }
  };



  onAssignmentClick = (assignment) => {
    var lessonVersionID = assignment.lessonVersionID;
    switch (assignment.assignmentIDs.length) {
      case 0: {
        break;
      }
      default: {
        this.router.navigate(
          [environment.rootPath + 'Assignment/' + lessonVersionID],
          {
            queryParams: {
              assignmentName: assignment.assignmentName
            },
          }
        );
        break;
      }
    }
  };



  // sortFunction(a: any, b: any){
  //   if(a.sequence == null){
  //     return 1;
  //   }
  //   if(a.sequence < b.sequence)
  //   {
  //     return -1;
  //   }
  //   else if(a.sequence > b.sequence)
  //   {
  //     return 1;
  //   }
  //   else
  //   {
  //     return 0;
  //   }
  // }



  sortAssignmentsByProperty = (a: any, b: any, property) => {
     // equal items sort equally
    if (a[property] === b[property]) {
      return 0;
    }
    // nulls sort after anything else
    else if (a[property] === null) {
        return 1;
    }
    else if (b[property] === null) {
        return -1;
    }
    // otherwise, if we're ascending, lowest sorts first
    else {
        return a[property] < b[property] ? -1 : 1;
    }
    // // if descending, highest sorts first
    // else {
    //     return a < b ? 1 : -1;
    // }
  }



  ngOnDestroy(): void {
    this.filterSubscription?.unsubscribe();
  }


  /**
   * This method is used to open dialog on click of Quick Add.
   */
   openDialog = (): void => {
    let arrAssignedAssignmentsId = [];
    let arrStudentIds = [];
    this.selectedAssignmentsObject.forEach(data => {
      if(data.selected) {
        arrAssignedAssignmentsId.push(data);
      }
    })
    if (arrAssignedAssignmentsId.length === 0) {
      this.toastr.warning('Assignment Lessons is Required', 'Warning!');
      return;
    }
    this.dataSource.filteredData.forEach((stuData: any) => {
      if (stuData.StudentID) {
        arrStudentIds.push(stuData.StudentID)
      }
    })
    let title = 'Quick Add';
    let text = 'Are you sure you want to Quick Add ' + arrAssignedAssignmentsId.length + ' assignments for '+
    arrStudentIds.length+ ' students';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title,
        text
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.confirmSelected.subscribe(
      (confirmSelected) => {
        this.CreateAssignments();
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  /**
   * This method is used to add assignments on click of quick add.
   */
  CreateAssignments = (): void => {
    let arrAssignedAssignmentsId = [];
    let arrStudentIds = [{classIDs: parseInt(this.classID, 10), StudentIDs: []}]
    this.selectedAssignmentsObject.forEach(data => {
      if(data.selected) {
        arrAssignedAssignmentsId.push(data.assignmentIDs[0]);
      }
    })
    this.dataSource.filteredData.forEach((stuData: any) => {
      if (stuData.StudentID) {
        arrStudentIds[0].StudentIDs.push(stuData.StudentID)
      }
    })
    const params = {
      Classes: arrStudentIds,
      AssignmentIDs: arrAssignedAssignmentsId,
      RemoveExtendedResponse: null,
      AssignOnlyUnassignedStudents: null,
      StartDate: null,
      EndDate: null,
    }
    this.dataService.CreateAssignments(params).subscribe(res => {
      if(res){
        Object.values(this.selectedAssignmentsObject).map(assignment => assignment.selected = false)
        this.toastr.success('Assignment added.', 'Success!');
      }
      else{
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  /**
   * This method is used to get list of array of classWithStudent.
   */
  GetClassesWithStudent = (): void => {
    if(!this.isAdmin) {
      // For Teacher
    this.dataService.GetClassesWithStudent().subscribe((res: ClassWithStudentsForListing[]) => {
      this.arrClassWithStudent = res;
    })
  } else {
    // For Admin
    this.dataService.GetClassListByTeacher().subscribe((res: ClassForListing[]) => {
      this.arrClassWithStudent = res;
      this.arrClassWithStudent.forEach((data: any) => {
        if((!data.Students || data.Students.length==0) && (data.HBClassID == this.classID)) {
          this.dataService.GetClassWithStudents(parseInt(this.classID, 10)).subscribe(res => {
            data.Students = res.Students;
          })
        } else {
          data.Students = [];
        }
      })
    })
  }
  }

  /**
   * This method is used to open dialog when clicked on Advance Assign.
   */
  openAdvanceAssignDialog = () => {
    let arrAssignedAssignmentsId = [];
    let arrStudentIds = [];
    this.selectedAssignmentsObject.forEach(data => {
      if(data.selected) {
        arrAssignedAssignmentsId.push(data);
      }
    })
    if (arrAssignedAssignmentsId.length === 0) {
      this.toastr.warning('Assignment Lessons is Required', 'Warning!');
      return;
    }

      if(this.searchStudentValue != '') {
        this.dataSource.filteredData.forEach((stuData: any) => {
          if (stuData.StudentID) {
            arrStudentIds.push(stuData.StudentID)
          }
        })
      }
        const dialogRef = this.dialog.open(AdvanceAssignDialogComponent, {
        data: {
          arrAssignment: arrAssignedAssignmentsId,
          arrClasses: this.arrClassWithStudent,
          selectedStudent: arrStudentIds,
          selectedClass: this.classID ? this.classID : null,
          isAdmin: this.isAdmin,
        },
        disableClose: true
      });
      const sub = dialogRef.componentInstance.valueUpdated.subscribe(
        (assignment) => {
          this.dataService.CreateAssignments(assignment).subscribe(res => {
            if(res){
              Object.values(this.selectedAssignmentsObject).map(assignment => assignment.selected = false)
              this.toastr.success('Assignment added.', 'Success!');
            }
            else{
              this.toastr.error('Something went wrong', 'Failure!');
            }
          })
        }
      );
      dialogRef.afterClosed().subscribe((result) => {
        sub.unsubscribe();
      });
  };

  /**
   * This method is used to get selected assignment.
   */
  getSelectedAssignment = (assignmentId, array): void => {
    if (array.length > 0) {
      array.forEach(data => {
        if (data.lessonVersionID== assignmentId) {
          data.selected = true;
          this.onLessonCheckboxClick(true, data);
          this.searchLessonValue = data.assignmentName;
          this.applyLessonFilter();
          this.openAdvanceAssignDialog();
        }
      })
    }
  }

  /**
   * This method is used to get selected student.
   */
  getSelectedStudent = (studentId, arrayData): void => {
    arrayData.forEach(sData => {
      if (sData.StudentID && sData.StudentID==studentId) {
        this.searchStudentValue = sData.Student && sData.Student.studentName ? sData.Student.studentName : sData.Student.cellValue;
        this.applyStudentFilter();
      }
    })
  }
}
